import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

// Configuración de tu proyecto en Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyCPoT0dPO396sGXFyHr7rDX8CLDWflvOJc",
  authDomain: "amigo-peludo-app.firebaseapp.com",
  projectId: "amigo-peludo-app",
  storageBucket: "amigo-peludo-app.firebasestorage.app",
  messagingSenderId: "142547163544",
  appId: "1:142547163544:web:ec7f44d807eccaa6bb33ed",
  measurementId: "G-0TZ2E755LX"
};

// Initialize Firebase (necesario para la web)
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      // Flujo Nativo (Android/iOS) con Capacitor
      const result = await FirebaseAuthentication.signInWithGoogle();
      return {
        success: true,
        user: {
          email: result.user?.email,
          name: result.user?.displayName || 'Usuario',
          uid: result.user?.uid,
          provider: 'google'
        }
      };
    } else {
      // Flujo Web (Navegador)
      const result = await signInWithPopup(auth, googleProvider);
      return {
        success: true,
        user: {
          email: result.user.email,
          name: result.user.displayName,
          uid: result.user.uid,
          provider: 'google'
        }
      };
    }
  } catch (error: any) {
    console.error("Error en Google Sign-In:", error);
    return {
      success: false,
      error: error.message || 'Error desconocido'
    };
  }
};
